// ── Charm Collection Grid — Client-side Filter + Pagination ──
// All products are loaded into the DOM by Liquid (paginate by 250).
// This script handles category/metal filtering AND pagination so the
// page count always reflects the filtered product count.
// Filter & page state is persisted in URL query params.
(function () {
  'use strict';

  // ── URL helpers ──

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function setParams(updates) {
    var params = new URLSearchParams(window.location.search);
    Object.keys(updates).forEach(function (key) {
      var val = updates[key];
      if (!val || val === 'all' || val === '1') {
        params.delete(key);
      } else {
        params.set(key, val);
      }
    });
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    window.history.replaceState(null, '', url);
  }

  // ── Main ──

  document.querySelectorAll('.charm-collection-section').forEach(function (section) {
    var filterPills = section.querySelector('.charm-filter-pills');
    var metalPills = section.querySelector('.charm-metal-pills');
    var grid = section.querySelector('.charm-collection-grid');
    var paginationNav = section.querySelector('.charm-collection-pagination');

    if (!grid) return;

    var allCards = Array.prototype.slice.call(grid.querySelectorAll('.charm-product-card'));
    var perPage = parseInt(grid.dataset.perPage) || 48;

    // Restore state from URL
    var activeFilter = getParam('filter') || 'all';
    var activeMetal = getParam('metal') || 'all';
    var currentPage = parseInt(getParam('page')) || 1;

    // ── Matching helpers ──

    function matchesCategory(card, filter) {
      if (filter === 'all') return true;
      var category = (card.dataset.category || '').toLowerCase();
      if (category === filter) return true;
      var tags = (card.dataset.tags || '').toLowerCase();
      var tagList = tags.split(',');
      for (var i = 0; i < tagList.length; i++) {
        var tagHandle = tagList[i].trim().replace(/[\s_]/g, '-');
        if (tagHandle === filter) return true;
      }
      return false;
    }

    function matchesMetal(card, metal) {
      if (metal === 'all') return true;
      var tags = (card.dataset.tags || '').toLowerCase();
      return tags.indexOf(metal) !== -1;
    }

    // ── Core render ──

    function render() {
      // 1. Determine which cards match the active filters
      var matchingCards = allCards.filter(function (card) {
        return matchesCategory(card, activeFilter) && matchesMetal(card, activeMetal);
      });

      var totalMatching = matchingCards.length;
      var totalPages = Math.max(1, Math.ceil(totalMatching / perPage));

      // Clamp current page
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;

      var startIdx = (currentPage - 1) * perPage;
      var endIdx = startIdx + perPage;

      // 2. Show/hide cards
      allCards.forEach(function (card) { card.classList.add('hidden-by-filter'); });
      for (var i = startIdx; i < endIdx && i < matchingCards.length; i++) {
        matchingCards[i].classList.remove('hidden-by-filter');
      }

      // 3. No-results message
      var existing = grid.querySelector('.charm-no-results');
      if (totalMatching === 0) {
        if (!existing) {
          var msg = document.createElement('div');
          msg.className = 'charm-no-results';
          msg.textContent = 'No products found for this filter.';
          grid.appendChild(msg);
        }
      } else if (existing) {
        existing.remove();
      }

      // 4. Build pagination
      renderPagination(totalPages);

      // 5. Sync URL (no reload — just update the address bar)
      setParams({
        filter: activeFilter,
        metal: activeMetal,
        page: String(currentPage)
      });
    }

    // ── Pagination renderer ──

    function renderPagination(totalPages) {
      if (!paginationNav) return;
      paginationNav.innerHTML = '';

      if (totalPages <= 1) return;

      // Previous arrow
      if (currentPage > 1) {
        paginationNav.appendChild(makePageLink(currentPage - 1, '\u00ab', 'Previous page'));
      }

      // Page numbers
      for (var p = 1; p <= totalPages; p++) {
        if (p === currentPage) {
          var span = document.createElement('span');
          span.className = 'current';
          span.textContent = p;
          paginationNav.appendChild(span);
        } else {
          paginationNav.appendChild(makePageLink(p, String(p)));
        }
      }

      // Next arrow
      if (currentPage < totalPages) {
        paginationNav.appendChild(makePageLink(currentPage + 1, '\u00bb', 'Next page'));
      }
    }

    function makePageLink(page, label, ariaLabel) {
      var a = document.createElement('a');
      a.href = '#';
      a.textContent = label;
      if (ariaLabel) a.setAttribute('aria-label', ariaLabel);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        currentPage = page;
        render();
        // Scroll to top of the grid
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return a;
    }

    // ── Pill UI sync ──

    function syncPillUI(container, activeValue, dataAttr) {
      if (!container) return;
      container.querySelectorAll('[data-' + dataAttr + ']').forEach(function (p) {
        p.classList.toggle('active', p.dataset[dataAttr] === activeValue);
      });
    }

    // ── Event listeners ──

    if (filterPills) {
      filterPills.addEventListener('click', function (e) {
        var pill = e.target.closest('.charm-filter-pill');
        if (!pill) return;
        activeFilter = pill.dataset.filter;
        currentPage = 1;
        syncPillUI(filterPills, activeFilter, 'filter');
        render();
      });
    }

    if (metalPills) {
      metalPills.addEventListener('click', function (e) {
        var pill = e.target.closest('.charm-metal-pill');
        if (!pill) return;
        activeMetal = pill.dataset.metal;
        currentPage = 1;
        syncPillUI(metalPills, activeMetal, 'metal');
        render();
      });
    }

    // ── Initial render ──
    syncPillUI(filterPills, activeFilter, 'filter');
    syncPillUI(metalPills, activeMetal, 'metal');
    render();
  });
})();
